import React, { useEffect, useState } from "react";
import SimpleImageSlider from "react-simple-image-slider";
import img1 from "../assest/banner/new-banner-1.jpg"
import img2 from "../assest/banner/new-banner-2.jpg"
import img3 from "../assest/banner/new-banner-3.jpg"
import img4 from "../assest/banner/new-banner-4.jpg"

const Slider =()=>{
    const [slider, setSlider]=useState(0)
    const imges=[img1,img2,img3,img4];

    const sliderPlus=()=>{
        setSlider(slider === imges.length-1 ? 0 : slider+1)
    }

    useEffect(()=>{
       const sldierClear = setInterval(() => {
            sliderPlus()
        },2000)

        return () => clearInterval(sldierClear)
    })


    return (

        <>    
        <section id="banner" className="section section-m1" >
            <div className="swiper">
            <div className="swiper-wrapper" style={{borderRadius:5}}>
            <SimpleImageSlider
            width={'100%'} 
            height={395} 
            images={imges} 
            showBullets={true} 
            showNavs={true}
            autoPlay={true}
             />
            </div>
          

            </div>
        </section>
        </>       
    )
}

export default Slider;